if(typeof vehicles !== 'undefined'){
  $.each(vehicles,function(index,value){
    if(typeof value !== 'undefined') {
      $.each(value,function(i,v){
        if(typeof v !== 'undefined' && typeof v === "string"){
          var str = v.replace(/_/g, ' ');
          $('select.make').append('<option value="'+v+'">'+str+'</option>');
        }
      });
    }
  });
}
$('.make').change(function() {
  var selected_val = $(this).val();
  if( selected_val != "" ) {
    $('.model').removeAttr('disabled');
    $('select.year').empty().attr("disabled","disabled");
    $('select.model').empty();
    $('select.model').append('<option value="">Select Model</option>');
    $('select.year').append('<option value="">Select Year</option>');
    $('#model_search').attr("disabled","disabled"); 
    if(typeof vehicles[selected_val] !== 'undefined'){
      $.each(vehicles[selected_val],function(index,value){
        $.each(value,function(i,v){
          var str = v.replace(/_/g, ' ');
          $('select.model').append('<option value="'+v+'">'+str+'</option>');
        });
      });
    } else {
      $('.model').attr("disabled", "disabled");
    }    
  } else {
    $('select.model, select.year').empty().attr("disabled","disabled");    
    $('select.model').append('<option value="">Select Model</option>');
    $('select.year').append('<option value="">Select Year</option>');
    $('#model_search').attr("disabled","disabled"); 
  }
});
$('.model').change(function(){  
  var selected_val = $(this).val();
  if( selected_val != "" ) {
    $('select.year').empty();
    $('select.year').append('<option value="">Select Year</option>');
    $('#model_search').attr("disabled","disabled"); 
    if(typeof vehicles[selected_val] !== 'undefined'){
      $.each(vehicles[selected_val],function(index,value){
        $.each(value,function(i,v){
          $('select.year').removeAttr("disabled");
          var str = v.replace(/_/g, ' ');
          $('select.year').append('<option value="'+v+'">'+str+'</option>');
        });
      });
    } else {
      $('select.year').attr("disabled", "disabled");
    }   
  } else {
    $('select.year').empty().attr("disabled","disabled");    
    $('select.year').append('<option value="">Select Year</option>');
    $('#model_search').attr("disabled","disabled"); 
  }
});
$('.year').change(function(){
  var selected_val = $(this).val();
  if( selected_val != "" ) {
    $('#model_search').removeAttr("disabled");
  } else {
    $('#model_search').attr("disabled","disabled"); 
  }
});
jQuery("body").on("click",".model_search", function(){      
  var tag1 = $(this).parents('ul').find('select.make').val();
  var tag2 = $(this).parents('ul').find('select.model').val();
  var tag3 = $(this).parents('ul').find('select.year').val();
  if(tag1 != "" && tag2 != "" && tag3 != "") {
    var v_modal = tag2.replace("-","_");
    var searchURL = '/search?type=product&q='+tag1+'+'+v_modal+'+'+tag3;    

    $.ajax({
      type: 'GET',
      url: searchURL,
      beforeSend: function() {
        console.log('Send');
      },
      success: function(data) {   
        if( $(data).find('.productgrid--item').length ){        	
          window.location.href = searchURL+"&year="+tag3+"&view=tags";
        }else{
          jQuery('#ymm_searchbox').append('<p class="search_msg" style="color: #ff0000; font-style:italic; text-align: center;">Product not found!</p>');
          setTimeout(function(){
            jQuery('#ymm_searchbox .search_msg').fadeOut();
          },3000);           	
        }
      },
      error: function(data) {
        location.reload();        
      },
      dataType: "html"
    });
    return false;
    /*
    $.getJSON(searchURL + '&view=json', function(data) {
       	console.log(data);   
      //return false;
      if(data.results.length > 1) {
        window.location.href = searchURL+"&year="+tag3+"&view=tags";
      } else {        
        var secResult = data.results[0];      
        if(typeof secResult !== 'undefined') {
          window.location.href = secResult.url+"&year="+tag3+"&view=tags";
        }
        else {
          jQuery('#ymm_searchbox').append('<p class="search_msg" style="color: #ff0000; font-style:italic; text-align: center;">Product not found!</p>');
          setTimeout(function(){
            jQuery('#ymm_searchbox .search_msg').fadeOut();
          },3000);
        }
      }
    });
    */
  }
});
//Reset function
jQuery("body").on('click','#ymm_reset',function(){                    
  $('select.model, select.year').empty().attr("disabled","disabled");    
  $('select.model').append('<option value="">Select Model</option>');
  $('select.year').append('<option value="">Select Year</option>');
  $('#model_search').attr("disabled","disabled"); 
  $('#make').find("option").first().attr('selected','selected').trigger('change');
}); 